import React from "react";
import { Box, Flex, Text } from "@telia/teddy";
import "./ReviewSummaryStats.less";

type Props = {
    reviewCount: number;
    avgScore: number | null;
};

const ReviewSummaryStats: React.FC<Props> = ({ reviewCount, avgScore }) => (
    <Flex direction="row" gap="400" wrap="wrap" className="review-summary-stats">
        <Box className="review-summary-stats__card">
            <Text className="review-summary-stats__card-value">{reviewCount}</Text>
            <Text className="review-summary-stats__card-label">Vurderinger</Text>
        </Box>
        {avgScore !== null && (
            <Box className="review-summary-stats__card">
                <Text className="review-summary-stats__card-value">{avgScore} / 5</Text>
                <Text className="review-summary-stats__card-label">Snittkarakter</Text>
            </Box>
        )}
    </Flex>
);

export default ReviewSummaryStats;
